import { atom } from "jotai";

export type ApplyPunchPassModalContext =
  | {
      type: "round";
      roundId: string;
      playerName: string;
    }
  | {
      type: "booking";
      bookingId: string;
      ownerName: string;
    };

// Combined atom: null = modal closed, non-null = modal open with context
export const applyPunchPassModalAtom = atom<ApplyPunchPassModalContext | null>(
  null
);
